import React from "react"

import INTERNATIONAL_SITES from "~models/InternationalSites"

const InternationalSites = ({ microcopy }) => (
  <ul>
    <li>{microcopy.text("footer.categories.international.title")}</li>
    {INTERNATIONAL_SITES.map((site, index) => (
      <li key={index}>
        <a href={site.url}>{site.name}</a>
      </li>
    ))}
  </ul>
)

export default InternationalSites
